import React from "react";
import { Outlet } from "react-router-dom";

const AdminOutlet = () => {
  return (
    <div className='App'>
      <Outlet />
    </div>
  );
};

export default AdminOutlet;
